export default [
  {
    path: '/meu-plano',
    name: 'meu-plano',
    component: () => import('@/views/account/MeuPlano.vue'),
    meta: {
      pageTitle: 'Meu Plano',
      breadcrumb: [
        {
          text: 'Meu Plano',
          active: true,
        },
      ],
    },
  },
  {
    path: '/forma-pagamento',
    name: 'forma-pagamento',
    component: () => import('@/views/account/FormaPagamento.vue'),
    meta: {
      pageTitle: 'Forma de Pagamento',
      breadcrumb: [
        {
          text: 'Forma de Pagamento',
          active: true,
        },
      ],
    },
  },
  {
    path: '/faturas',
    name: 'faturas',
    component: () => import('@/views/account/Faturas.vue'),
    meta: {
      pageTitle: 'Faturas',
      breadcrumb: [
        {
          text: 'Faturas',
          active: true,
        },
      ],
    },
  },
]
